import React from 'react';
import { Box, HStack, VStack, Text, Image } from '@chakra-ui/react';
import { useTranslation } from '../../hooks/useTranslation';

/**
 * Общий блок: логотип + название компании Office Hof и подзаголовок "Личный кабинет".
 * Используется на экранах логина и регистрации.
 */
export const CompanyLogoHeader: React.FC = () => {
    const { t } = useTranslation();

    return (
        <HStack justify="center" gap={4}>
            <Box
                w={12}
                h={12}
                borderRadius="lg"
                display="flex"
                alignItems="center"
                justifyContent="center"
                overflow="hidden"
            >
                <Image src="/favicon-192x192.png" alt="Office Hof" boxSize={12} objectFit="contain" />
            </Box>
            <VStack align="start" gap={0}>
                <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                    Office Hof
                </Text>
                <Text fontSize="sm" color="gray.500">
                    {t.login.subtitle}
                </Text>
            </VStack>
        </HStack>
    );
};
